import {
  Component,
  Inject,
  OnInit,
  PLATFORM_ID
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Router } from '@angular/router';

import { LoginService } from '../../../Authentication/auth/login.service';
import { UserService } from '../../../../services/user';
import { PetServices } from '../../../../services/petservices';


@Component({
  selector: 'app-myclinicservices',
  templateUrl: './myclinicservices.component.html',
  styleUrl: './myclinicservices.component.scss'
})
export class MyclinicservicesComponent implements OnInit {

  contentReady = false;
  noData = false;

  isAr = false;
  tokenExists = false;

  allData: any[] = [];
  bookingsTotal: any = 0;

  page = 1;
  perPage = 10;

  private isBrowser: boolean;

  constructor(
    private _petServices: PetServices,
    private _LoginService: LoginService,
    private _userService: UserService,
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngOnInit(): void {
    if (this.isBrowser) {
      this.isAr = localStorage.getItem('language') === 'ar';
    }

    this.checkForToken();
  }

  // ================= AUTH =================
  checkForToken(): void {
    this._LoginService.token$.subscribe((token) => {
      this.tokenExists = token != null;

      if (this.tokenExists) {
        this.getUserClinicBookings(1);
      } else {
        this.noData = true;
        this.contentReady = false;
      }
    });
  }

  // ================= DATA =================
  getUserClinicBookings(page: number = 1): void {
    this.contentReady = true;
    this.page = page;

    this._userService.getUserId().subscribe({
      next: (data) => {
        this._petServices.getBookingsByUser(data.user_id, page, this.perPage).subscribe({
          next: (res) => {
            this.allData = res?.data || [];
            this.bookingsTotal = res?.total || this.allData.length;

            this.noData = this.allData.length === 0;
            this.contentReady = false;
          },
          error: (error) => {
            console.error('Bookings error:', error);
            this.noData = true;
            this.contentReady = false;
          }
        });
      },
      error: (error) => {
        console.error('User id error:', error);
        this.noData = true;
        this.contentReady = false;
      }
    });
  }

  // ================= HELPERS =================
  goBack(): void {
    if (!this.isBrowser) return;
    window.history.back();
  }

  convertDate(dateString: any): string {
    if (!dateString) return '-';

    const date = new Date(dateString);
    const day = ('0' + date.getDate()).slice(-2);
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  }

  convertDateTime(dateString: any): string {
    if (!dateString) return '-';

    const date = new Date(dateString);

    const day = ('0' + date.getDate()).slice(-2);
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const year = date.getFullYear();

    let hours = date.getHours();
    const minutes = ('0' + date.getMinutes()).slice(-2);
    const ampm = hours >= 12 ? 'PM' : 'AM';

    hours = hours % 12;
    hours = hours ? hours : 12;

    return `${day}-${month}-${year} - ${hours}:${minutes} ${ampm}`;
  }

  getService(booking: any): any {
    return booking?.pet_service || booking?.petService || null;
  }

  getServiceName(booking: any): string {
    const service = this.getService(booking);

    if (!service) {
      return this.isAr ? 'خدمة عيادة' : 'Clinic Service';
    }

    if (this.isAr) {
      return service.name_ar || service.title_ar || service.name || service.name_en || 'خدمة عيادة';
    }

    return service.name_en || service.title_en || service.name || service.name_ar || 'Clinic Service';
  }

  getServicePrice(booking: any): any {
    const service = this.getService(booking);
    return service?.pricec || service?.price || service?.affiliationprice || null;
  }

  getPetTypeLabel(petType: any): string {
    if (!petType) return this.isAr ? 'غير محدد' : 'Not selected';

    const value = String(petType).toLowerCase();

    if (value === 'cat' || value === 'cats' || value === '0') {
      return this.isAr ? 'قطط' : 'Cats';
    }

    if (value === 'dog' || value === 'dogs' || value === '1') {
      return this.isAr ? 'كلاب' : 'Dogs';
    }

    if (value === 'bird' || value === 'birds' || value === '2') {
      return this.isAr ? 'طيور' : 'Birds';
    }

    return petType;
  }

  deleteBooking(bookingId: number): void {
    if (!bookingId) return;

    this.contentReady = true;

    this._petServices.deleteBooking(bookingId).subscribe({
      next: () => {
        this.getUserClinicBookings(1);
      },
      error: (error) => {
        console.error('Delete booking error:', error);
        this.contentReady = false;
      }
    });
  }

  callClient(phone: string): void {
    if (!this.isBrowser || !phone) return;
    window.open(`tel:${phone}`, '_blank');
  }

  chatClient(phone: string): void {
    if (!this.isBrowser || !phone) return;

    const cleanPhone = String(phone).replace(/\D/g, '');
    window.open(`https://api.whatsapp.com/send?phone=2${cleanPhone}`, '_blank');
  }
}